<template>
    <div class="col-lg-12">
        <div class="card border-top-0">
            <div class="card-body personal-info">
                <form @submit.prevent="submitForm">
                    <div class="mb-4 d-flex align-items-center justify-content-between">
                        <h5 class="fw-bold mb-0 me-4">
                            <span class="d-block mb-2">Tedarikçi Kartı Düzenle:</span>
                            <span class="fs-12 fw-normal text-muted text-truncate-1-line">Tedarikçi kartlarını
                                buradan düzenleyebilirsiniz.</span>
                        </h5>
                        <div class="d-flex gap-2">
                            <button type="submit" class="btn btn-lg btn-light-brand bg-green text-white">Kaydet</button>
                        </div>
                    </div>
                    <div class="row mb-4 align-items-center">
                        <div class="col-lg-2">
                            <label class="fw-semibold">Tedarikçi Adı: </label>
                        </div>
                        <div class="col-lg-10">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="supplier.name"
                                    placeholder="Tedarikçi Adı">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4 align-items-center">
                        <div class="col-lg-2">
                            <label class="fw-semibold">Telefonu: </label>
                        </div>
                        <div class="col-lg-10">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="supplier.phone"
                                    placeholder="Tedarikçi Telefonu">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4 align-items-center">
                        <div class="col-lg-2">
                            <label class="fw-semibold">E-Posta: </label>
                        </div>
                        <div class="col-lg-10">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="supplier.email" placeholder="E-Posta">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4 align-items-center">
                        <div class="col-lg-2">
                            <label class="fw-semibold">Vergi Dairesi: </label>
                        </div>
                        <div class="col-lg-10">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="supplier.tax_office"
                                    placeholder="Vergi Dairesi">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4 align-items-center">
                        <div class="col-lg-2">
                            <label class="fw-semibold">Vergi Numarası: </label>
                        </div>
                        <div class="col-lg-10">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="supplier.tax_number"
                                    placeholder="Vergi Numarası">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4 align-items-center">
                        <div class="col-lg-2">
                            <label class="fw-semibold">Adresi: </label>
                        </div>
                        <div class="col-lg-10">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="supplier.address" placeholder="Adresi">
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';
export default {
    name: 'EditSupplier',
    data() {
        return {
            supplier: {},
        }
    },
    async mounted() {
        const supplierId = this.$route.params.id;
        console.log(supplierId);
        if (supplierId) {
            await this.fetchSupplier(supplierId);
        }
    },
    methods: {
        async fetchSupplier(id) {
            try {
                const response = await this.$axios.get(`supplier/${id}/`);
                this.supplier = response.data;
            } catch (error) {
                Swal.fire('Hata', error, 'error');
            }
        },
        async submitForm() {
            console.log('kayıttan önce supplier:', this.supplier);
            try {
                const response = await this.$axios.put(`supplier/${this.supplier.id}/`, this.supplier);
                Swal.fire('Başarılı', 'Tedarikçi başarıyla güncellendi.', 'success');
                console.log(response);
                this.$router.push({ name: 'Suppliers', params: { page: 1 } });

            } catch (error) {
                Swal.fire('Hata', error, 'error');
                console.log(error);
            }
        }
    }
}
</script>